import React, { useEffect, useImperativeHandle, useRef, forwardRef, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import {
  amountFormatter,
  checkKey,
  lpad,
  nvl,
  parseNumber,
  toNull,
  toSingleByte,
  onFocusText,
  onKeyDownNext,
  CONST_TAX_EXEMPT,
  CONST_TAX_NON_TAX,
  CONST_TAX_EXP_10,
  CONST_TAX_EXP_08,
  CONST_TAX_INC_10,
  CONST_TAX_INC_08,
  moveFocus,
  moveCellByArrow,
  sleepByPromise,
  onKeyDownShortCut,
  calcLineTaxAmount,
  calcLineWithholdTaxAmount
} from "../CMUtil";
import { getAPI } from "../APIUtil";
import AsyncSelect from "react-select/async";

export const ExpDtlLine = React.forwardRef((props, ref) => {

  const lineTaxClassList = [
    { id: CONST_TAX_EXP_10, name: "外税10%" },
    { id: CONST_TAX_EXP_08, name: "外税8%" },
    { id: CONST_TAX_INC_10, name: "内税10%" },
    { id: CONST_TAX_INC_08, name: "内税8%" },
    { id: CONST_TAX_EXEMPT, name: "非課税" },
    { id: CONST_TAX_NON_TAX, name: "不課税" }
  ];

  const [index, setIndex] = useState("");
  const [expDtlId, setExpDtlId] = useState("");
  const [expId, setExpId] = useState("");
  const [lineNo, setLineNo] = useState(0);
  const [accSelected, setAccSelected] = useState(null);
  const [accCd, setAccCd] = useState("");
  const [accSuffixSelected, setAccSuffixSelected] = useState(null);
  const [accSuffixCd, setAccSuffixCd] = useState("");
  const [expenseSelected, setExpenseSelected] = useState(null);
  const [expenseCl, setExpenseCl] = useState(0);
  const [deptSelected, setDeptSelected] = useState(null);
  const [deptCd, setDeptCd] = useState("");
  const [itemSelected, setItemSelected] = useState(null);
  const [itemCd, setItemCd] = useState("");
  const [editColumn, setEditColumn] = useState("");
  // const [dutyFreeFG, seDutyFreeFG] = useState(0);

  // const itemCdRequireAccCdList = [555, 557];

  const [costCd, setCostCd] = useState("");
  const [remarkSelected, setRemarkSelected] = useState(null);
  const [remarkCd, setRemarkCd] = useState("");
  const [note, setNote] = useState("");
  const [lineAmount, setLineAmount] = useState("");
  const [lineAmountEx, setLineAmountEx] = useState(0);
  const [lineTaxClassSelected, setLineTaxClassSelected] = useState(null);
  const [lineTaxClassCd, setLineTaxClassCd] = useState(0);
  const [lineTaxRate, setLineTaxRate] = useState("");
  const [lineTaxAmount, setLineTaxAmount] = useState("");
  const [lineTotalAmount, setLineTotalAmount] = useState("");
  const [lineWithHoldTaxAmount, setLineWithHoldTaxAmount] = useState("");
  const [linePayAmount, setLinePayAmount] = useState("");

  const [isHeadUpdated, setIsHeadUpdated] = useState(false);
  const [isLineUpdated, setIsLineUpdated] = useState(false);

  const [selectMenuOpen, setSelectMenuOpen] = useState(false);

  const _ref = useRef(null);

  //初期化
  useEffect(() => {
    const update = async () => {

      // 初期化
      setIndex(nvl(props.index));
      let line = props.line;
      setExpDtlId(nvl(line.exp_dtl_id));
      setExpId(nvl(line.exp_id));
      if (line.acc_cd) {
        setAccSelected([{ id: line.acc_cd, name: lpad(nvl(line.acc_cd), 2, "0") + " " + nvl(line.acc_nm) }]);
        setAccCd(line.acc_cd);
      }
      if (line.acc_suffix_cd) {
        setAccSuffixSelected([{ id: line.acc_suffix_cd, name: lpad(nvl(line.acc_suffix_cd), 2, "0") + " " + nvl(line.acc_suffix_nm) }]);
        setAccSuffixCd(line.acc_suffix_cd);
      }
      if (line.expense_cl) {
        setExpenseSelected([{ id: line.expense_cl, name: lpad(nvl(line.expense_cl), 2, "0") + " " + nvl(line.expense_cl_nm) }]);
        setExpenseCl(line.expense_cl);
      }
      if (line.dept_cd) {
        setDeptSelected([{ id: line.dept_cd, name: lpad(nvl(line.dept_cd), 2, "0") + " " + nvl(line.dept_nm) }]);
        setDeptCd(line.dept_cd);
      }
      if (line.line_tax_class_cd) {
        setLineTaxClassSelected(lineTaxClassList.find(t => t.id === line.line_tax_class_cd));
        setLineTaxClassCd(line.line_tax_class_cd);
      }
      setLineAmount(nvl(amountFormatter(line.line_amount)));
      setLineTaxAmount(nvl(amountFormatter(line.line_tax_amount)));
      setLineTotalAmount(nvl(amountFormatter(line.line_total_amount)));
      setLineWithHoldTaxAmount(nvl(amountFormatter(line.line_withhold_tax_amount)));
      setLinePayAmount(nvl(amountFormatter(line.line_pay_amount)));
      if (line.item_cd) {
        setItemSelected({ id: line.item_cd, name: nvl(line.item_cd) + " " + nvl(line.item_name) });
        setItemCd(line.item_cd);
      }
      setCostCd(nvl(line.cost_cd));
      if (line.remark_cd) {
        setRemarkCd(line.remark_cd);
        setRemarkSelected({
          id: line.remark_cd,
          name: line.remark_cd
        });
      }
      setNote(nvl(line.note));
    }
    update();
  }, []);

  //呼出元への返却
  useImperativeHandle(ref, () => ({
    getStates: () => {
      // 数値項目の未入力は0、文字列項目の未入力はnull（明細が空の行は全てnullのまま）
      const hasData = !!(accCd || expenseCl);
      const toNum = (val) => {
        const n = toNull(parseNumber(val));
        return n == null && hasData ? 0 : n;
      };
      return {
        index: toNull(index),
        exp_id: toNull(expId),
        exp_dtl_id: toNull(expDtlId),
        acc_cd: toNull(accCd),
        acc_suffix_cd: toNull(accSuffixCd),
        expense_cl: toNull(expenseCl),
        item_cd: toNull(itemCd),
        dept_cd: toNull(deptCd),
        line_tax_class_cd: toNull(lineTaxClassCd),
        line_amount: toNum(lineAmount),
        line_tax_amount: toNum(lineTaxAmount),
        line_total_amount: toNum(lineTotalAmount),
        line_withhold_tax_amount: toNum(lineWithHoldTaxAmount),
        line_pay_amount: toNum(linePayAmount),
        cost_cd: toNull(costCd),
        remark_cd: toNull(remarkCd),
        note: toNull(note),
        edit_column: toNull(editColumn),
        create_pg: 'ExpDtlLine',
        update_pg: 'ExpDtlLine',
        is_head_updated: isHeadUpdated,
        is_line_updated: isLineUpdated
      };
    },
    setSavedIds: (pExpId, pExpDtlId) => {
      setExpId(nvl(pExpId));
      setExpDtlId(nvl(pExpDtlId));
    },
    setLineAmount: (pLineAmount) => {
      setLineAmount(pLineAmount);
    },
    setLineTaxAmount: (pLineTaxAmount) => {
      setLineTaxAmount(pLineTaxAmount);
    },
    setLineTotalAmount: (pLineTotalAmount) => {
      setLineTotalAmount(pLineTotalAmount);
    },
    setLineWithholdTaxAmount: (pWithholdTaxAmount) => {
      setLineWithHoldTaxAmount(pWithholdTaxAmount);
    },
    setLinePayAmount: (pLinePayAmount) => {
      setLinePayAmount(pLinePayAmount);
    },
    isEmpty: () => {
      if (accCd) {
        return false;
      }
      if (accSuffixCd) {
        return false;
      }
      if (expenseCl) {
        return false;
      }
      if (itemCd) {
        return false;
      }
      if (deptCd) {
        return false;
      }
      if (lineTaxClassCd) {
        return false;
      }
      if (lineAmount) {
        return false;
      }
      if (lineTaxAmount) {
        return false;
      }
      if (lineTotalAmount) {
        return false;
      }
      if (lineWithHoldTaxAmount) {
        return false;
      }
      if (linePayAmount) {
        return false;
      }
      if (costCd) {
        return false;
      }
      if (remarkCd) {
        return false;
      }
      if (note) {
        return false;
      }
      return true;
    },
    getSelectedValues: () => {
      return {
        accSelected,
        accCd,
        accSuffixSelected,
        accSuffixCd,
        expenseSelected,
        expenseCl,
        lineTaxClassSelected,
        lineTaxClassCd,
        remarkSelected,
        remarkCd,
        deptSelected,
        deptCd,
        itemSelected,
        itemCd,
        costCd,
        note
      };
    },
    copyFromPrev: (values) => {
      if (values.accSelected) {
        setAccSelected(values.accSelected);
        setAccCd(values.accCd);
      }
      if (values.accSuffixSelected) {
        setAccSuffixSelected(values.accSuffixSelected);
        setAccSuffixCd(values.accSuffixCd);
      }
      if (values.expenseSelected) {
        setExpenseSelected(values.expenseSelected);
        setExpenseCl(values.expenseCl);
      }
      if (values.lineTaxClassSelected) {
        setLineTaxClassSelected(values.lineTaxClassSelected);
        setLineTaxClassCd(values.lineTaxClassCd);
      }
      if (values.remarkSelected) {
        setRemarkSelected(values.remarkSelected);
        setRemarkCd(values.remarkCd);
      }
      if (values.deptSelected) {
        setDeptSelected(values.deptSelected);
        setDeptCd(values.deptCd);
      }
      if (values.itemSelected) {
        setItemSelected(values.itemSelected);
        setItemCd(values.itemCd);
      }
      if (values.costCd) {
        setCostCd(values.costCd);
      }
      if (values.note) {
        setNote(values.note);
      }
    }
  }), [
    accCd,
    accSuffixCd,
    expenseCl,
    itemCd,
    deptCd,
    lineTaxClassCd,
    lineAmount,
    lineTaxAmount,
    lineTotalAmount,
    lineWithHoldTaxAmount,
    linePayAmount,
    costCd,
    remarkCd,
    note,
    accSelected,
    accSuffixSelected,
    expenseSelected,
    lineTaxClassSelected,
    remarkSelected,
    deptSelected
  ]);

  // リスト関数
  const onSearchAcc = async (query) => {
    if (!query) {
      return props.accList;
    }
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_acc1_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
      id: obj.acc_cd
    }));
    return o;
  }

  const handleChangeAcc = async (value) => {
    setAccSelected(value);
    setAccCd(value ? value.id : "");
    if (!value) {
      handleClearLine();
      return;
    }

    setTimeout(() => {
      onKeyDownNext();
    }, 100); // バグ対応：遅延させることでカーソル表示
  }

  const onSearchAccSuffix = async (query) => {
    let searchCondition = {
      acc_cd: accCd,
      search_value: query
    }
    const res = await getAPI("ms_acc2_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.acc_suffix_cd), 3, "0") + " " + nvl(obj.acc_suffix_nm),
      id: obj.acc_suffix_cd
    }));
    return o;
  }

  const handleChangeAccSuffix = async (value) => {
    setAccSuffixSelected(value);
    setAccSuffixCd(value ? value.id : "");
    if (!value) {
      return;
    }

    onKeyDownNext();
  }

  const onSearchExpense = async (query) => {
    if (!query) {
      return props.expenseList;
    }
    let searchCondition = {
      expense_cl_nm: query
    }
    const res = await getAPI("ms_expense_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.expense_cl), 2, "0") + " " + nvl(obj.expense_cl_nm),
      id: obj.expense_cl
    }));
    return o;
  }

  const handleChangeExpense = async (value) => {
    if (!value) {
      setExpenseSelected(null);
      setExpenseCl("");
      return;
    }
    setExpenseSelected(value);
    setExpenseCl(value.id);
    onKeyDownNext();
  }

  const onSearchRemark = async (query) => {
    if (!query) {
      return props.remarkList;
    }
    let searchCondition = {
      remark_nm: query
    }
    const res = await getAPI("ms_remark_typeahead_view", searchCondition);
    return res.results.map((obj) => ({
      name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
      id: obj.remark_cd,
      remark_nm: nvl(obj.remark_nm)
    }));
  }

  const handleChangeRemark = async (value) => {
    if (!value) {
      setRemarkSelected(null);
      setRemarkCd("");
      return;
    }
    setRemarkSelected({
      id: value.id,
      name: value.id
    });
    setRemarkCd(value.id);
    setNote(value.remark_nm);
    onKeyDownNext();
  }

  const onSearchDept = async (query) => {
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_dept_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.dept_cd), 2, "0") + " " + nvl(obj.dept_nm),
      id: obj.dept_cd
    }));
    return o;
  }

  const handleChangeDept = async (value) => {
    setDeptSelected(value);
    setDeptCd(value ? value.id : "");
    if (!value) {
      return;
    }

    onKeyDownNext();
  }

  const onSearchLineTaxClass = async (query) => {
    if (!query) {
      return lineTaxClassList;
    }
    let list = [];
    for (let lineTaxClass of lineTaxClassList) {
      if (lineTaxClass.name.trim().indexOf(query) > -1) {
        list.push(lineTaxClass);
      }
    }
    return list;
  }

  const handleChangeLineTaxClass = async (value) => {
    setLineTaxClassSelected(value);
    setLineTaxClassCd(value ? value.id : "");
    if (!value) {
      return;
    }

    await sleepByPromise(0.02);
    if (value.id === CONST_TAX_INC_08 || value.id === CONST_TAX_INC_10) {
      moveFocus(100 * (index + 1) + 1007); // 税込合計へフォーカス
    } else {
      moveFocus();
    }
  }

  const onSearchItem = async (query) => {
    if (!query) {
      return props.itemList;
    }
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_item_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: nvl(obj.item_cd) + " " + nvl(obj.item_name),
      id: obj.item_cd
    }));
    return o;
  }

  const handleChangeItem = async (value) => {
    setItemSelected(value);
    setItemCd(value ? value.id : "");
    if (!value) {
      return;
    }

    onKeyDownNext();
  }

  const onFocusCol = async (e) => {
    await sleepByPromise(0.02);
    onFocusText(e);
    props.appendLine();
  }

  const handleClearLine = () => {
    setAccSelected(null);
    setAccCd("");
    setAccSuffixSelected(null);
    setAccSuffixCd("");
    setExpenseSelected(null);
    setExpenseCl("");
    setLineTaxClassSelected(null);
    setLineTaxClassCd("");
    setLineAmount("");
    setLineTaxAmount("");
    setLineTotalAmount("");
    setLineWithHoldTaxAmount("");
    setLinePayAmount("");
    setItemSelected(null);
    setItemCd("");
    setDeptSelected(null);
    setDeptCd("");
    setCostCd("");
    setRemarkSelected(null);
    setRemarkCd("");
    setNote("");
  }

  const handleKeyDownNote = (e) => {
    if (e.target.tagName === "TEXTAREA" && e.key === "Enter") {
      if (e.altKey) {
        e.preventDefault();
        const el = e.target;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const newVal = note.slice(0, start) + "\n" + note.slice(end);
        setNote(newVal);
        setTimeout(() => {
          el.selectionStart = el.selectionEnd = start + 1;
        }, 0);
      } else {
        onKeyDownNext(e);
      }
    }
  }

  // 行計算 ///////////////////////////////////////////////////////////////////////////////

  // 金額
  const onBlurLineAmount = async (lineAmount) => {
    let cLineAmount = parseNumber(toSingleByte(lineAmount));
    if (cLineAmount === "") {
      return; // 空文字は処理終了
    }
    let cLineTaxAmount = calcLineTaxAmount(lineTaxClassCd, cLineAmount);
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, lineTaxClassCd, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 消費税
  const onBlurLineTaxAmount = async (lineTaxAmount) => {
    let cLineTaxAmount = parseNumber(toSingleByte(lineTaxAmount));
    if (cLineTaxAmount === "") {
      return; // 空文字は処理終了
    }
    let cLineAmount = parseNumber(toSingleByte(lineAmount));
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, lineTaxClassCd, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 税込合計
  const onBlurLineAmountEx = async (lineAmountEx) => {
    let cLineAmountEx = parseNumber(toSingleByte(lineAmountEx));
    if (cLineAmountEx === "") {
      return; // 空文字は処理終了
    }
    let cLineTaxAmount = calcLineTaxAmount(lineTaxClassCd, cLineAmountEx);
    let cLineAmount = cLineAmountEx - cLineTaxAmount;
    let cLineTotalAmount = cLineAmountEx;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, lineTaxClassCd, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineAmountEx(nvl(amountFormatter(cLineAmountEx)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 摘要
  const onBlurRemarkCd = async (remarkCd) => {
    let cLineAmount = parseNumber(toSingleByte(lineAmount));
    let cLineTaxAmount = parseNumber(toSingleByte(lineTaxAmount));
    let cLineTotalAmount = parseNumber(toSingleByte(lineTotalAmount));
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, lineTaxClassCd, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 源泉所得税
  const calcLineWithHoldTaxAmount = async (lineWithholdTaxAmount) => {
    let cLineWithholdTaxAmount = parseNumber(toSingleByte(lineWithholdTaxAmount));
    let cLineTotalAmount = parseNumber(toSingleByte(lineTotalAmount));
    if (cLineWithholdTaxAmount === "") {
      cLineWithholdTaxAmount = 0; // 未入力は0として扱う
    }
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const calcLine = async (targetName) => {

    // let cLineAmount = lineAmount ? parseNumber(lineAmount) : 0;
    // let cLineTaxRate = lineTaxRate ? parseNumber(lineTaxRate) : 0;
    // let cLineTaxAmount = lineTaxAmount ? parseNumber(lineTaxAmount) : 0;
    // let cLineTotalAmount = lineTotalAmount ? parseNumber(lineTotalAmount) : 0;
    // let cLineWithHoldTaxAmount = lineWithHoldTaxAmount ? parseNumber(lineWithHoldTaxAmount) : 0;
    // let cLinePayAmount = linePayAmount ? parseNumber(linePayAmount) : 0;
    //
    // // 税率
    // if (lineTaxClassCd === CONST_TAX_EXP_08 || lineTaxClassCd === CONST_TAX_INC_08) {
    //   cLineTaxRate = 0.08;
    // } else if (lineTaxClassCd === CONST_TAX_EXEMPT || lineTaxClassCd === CONST_TAX_NON_TAX) {
    //   cLineTaxRate = 0;
    // } else {
    //   cLineTaxRate = 0.1;
    // }
    //
    // // 消費税
    // if (targetName === "lineAmount" || targetName === "lineTotalAmount") {
    //   // 金額 or 税込金額を編集した時のみ、消費税再計算する
    //   if (lineTaxClassCd === CONST_TAX_EXP_08 || lineTaxClassCd === CONST_TAX_EXP_10) {
    //     cLineTaxAmount = r(cLineAmount * cLineTaxRate, R_ROUND, 0); // 外税
    //   } else if (lineTaxClassCd === CONST_TAX_INC_08 || lineTaxClassCd === CONST_TAX_INC_10) {
    //     cLineTaxAmount = r(cLineTotalAmount / (1 + cLineTaxRate) * cLineTaxRate, R_ROUND, 0); // 内税
    //   } else {
    //     cLineTaxAmount = 0; // 非課税・不課税
    //   }
    // }
    //
    // // 税抜金額 or 税込金額
    // if (targetName === "lineAmount" || targetName === "lineTotalAmount" || targetName === "lineTaxAmount") {
    //   if (lineTaxClassCd === CONST_TAX_EXP_08 || lineTaxClassCd === CONST_TAX_EXP_10) {
    //     cLineTotalAmount = cLineAmount + cLineTaxAmount; // 外税
    //   } else if (lineTaxClassCd === CONST_TAX_INC_08 || lineTaxClassCd === CONST_TAX_INC_10) {
    //     cLineAmount = cLineTotalAmount - cLineTaxAmount; // 内税
    //   } else {
    //     cLineTotalAmount = cLineAmount; // 非課税・不課税
    //   }
    //   // 源泉所得税
    //   cLineWithHoldTaxAmount = r(cLineAmount * 0.1021, 2, 0);
    // }
    //
    // // 支払金額
    // if (targetName === "lineAmount" || targetName === "lineTotalAmount" || targetName === "lineTaxAmount" || targetName === "lineWithHoldTaxAmount") {
    //   cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;
    // }
    //
    // // セット
    // setLineAmount(cLineAmount.toString());
    // setLineTaxRate(cLineTaxRate.toString());
    // setLineTaxAmount(cLineTaxAmount.toString());
    // setLineTotalAmount(cLineTotalAmount.toString());
    // setLineWithHoldTaxAmount(cLineWithHoldTaxAmount.toString());
    // setLinePayAmount(cLinePayAmount.toString());
    //
    // //親コンポーネントで再集計（レンダリングを起こす）
    // setOnBlurCallbackCount(onBlurCallbackCount + 1);
  }

  return (
    <div>
      <Row
        onKeyDown={(e) => {
          // セレクトは各onKeyDownで処理済み（メニュー表示中の矢印キーは選択肢操作）
          if (!e.target.closest(".async-select") && moveCellByArrow(e)) {
            return;
          }
          onKeyDownShortCut(e, null, props.onClickExpSave, props.onKeyDownEsc);
        }}
      >
        <Col lg={5}>
          <Row className="tbl-b-00">
            <Col lg="1" className="tbl-b-00-start" style={{ borderBottom: "none", backgroundColor: "#e3e5e9", fontWeight: "bold" }}>
              {index + 1}
            </Col>
            <Col lg="3" className="col-editable" style={{ padding: "0" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + 1001}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={accSelected}
                onFocus={e => props.onFocusAcc(props.index)}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100);
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchAcc(e)}
                onChange={e => handleChangeAcc(e)}
                placeholder=""
                isClearable
                styles={{
                  menu: (base) => ({
                    ...base,
                    minWidth: "200px",
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            </Col>
            <Col lg="4" className="col-editable" style={{ padding: "0" }}>
              <AsyncSelect
                key={accCd || 'default'}
                tabIndex={100 * (index + 1) + 1002}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={accSuffixSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100);
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchAccSuffix(e)}
                onChange={e => handleChangeAccSuffix(e)}
                placeholder=""
                isClearable
                styles={{
                  menu: (base) => ({
                    ...base,
                    minWidth: "200px",
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            </Col>
            <Col lg="4" className="col-editable" style={{ padding: "0" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + +1003}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={expenseSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchExpense(e)}
                onChange={e => handleChangeExpense(e)}
                placeholder=""
                isClearable
                styles={{
                  menu: (base) => ({
                    ...base,
                    minWidth: "200px",
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            </Col>
          </Row>
          <Row className="tbl-b-00">
            <Col lg="1" className="tbl-b-00-start"
              style={{ borderTopColor: "#e3e5e9", borderBottom: "solid 1px #AAAAAA", backgroundColor: "#e3e5e9", fontWeight: "bold" }}>
            </Col>
            <Col lg="7" className="col-editable" style={{ padding: "0", borderBottom: "solid 1px #AAAAAA" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + 1011}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={itemSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100);
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchItem(e)}
                onChange={e => handleChangeItem(e)}
                placeholder=""
                isClearable
                styles={{
                  menu: (base) => ({
                    ...base,
                    minWidth: "600px",
                    background: "white",
                  }),
                  menuList: (base) => ({
                    ...base,
                    background: "white",
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            </Col>
            <Col lg="4" className="col-editable" style={{ padding: "0", padding: "0", borderBottom: "solid 1px #AAAAAA" }}>
              <AsyncSelect
                key={accSelected?.id || 'default'}
                tabIndex={100 * (index + 1) + 1012}
                // name="DeptCd"
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={deptSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchDept(e)}
                onChange={handleChangeDept}
                placeholder=""
                isClearable
              />
            </Col>
          </Row>
        </Col>
        <Col lg={7}>
          <Row className="tbl-b-00">
            <Col className="col-editable col-lg" style={{ padding: "0" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + 1004}
                name="lineTaxClass"
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={lineTaxClassSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchLineTaxClass(e)}
                onChange={handleChangeLineTaxClass}
                onBlur={(e) => calcLine("lineTaxClass")}
                placeholder=""
                isClearable
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1005}
                name="lineAmount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={amountFormatter(lineAmount)}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                disabled={lineTaxClassSelected?.id && (lineTaxClassSelected?.id === CONST_TAX_INC_08 || lineTaxClassSelected?.id === CONST_TAX_INC_10)}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLineAmount(e.target.value)}
                onBlur={e => onBlurLineAmount(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1006}
                name="lineTaxAmount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={amountFormatter(lineTaxAmount)}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusText(e)}
                onChange={e => setLineTaxAmount(e.target.value)}
                onBlur={e => onBlurLineTaxAmount(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1007}
                name="lineTotalAmount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={amountFormatter(lineTotalAmount)}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                disabled={lineTaxClassSelected?.id && (lineTaxClassSelected?.id !== CONST_TAX_INC_08 && lineTaxClassSelected?.id !== CONST_TAX_INC_10)}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLineTotalAmount(e.target.value)}
                onBlur={e => onBlurLineAmountEx(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1008}
                name="lineWithHoldTaxAmount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={amountFormatter(lineWithHoldTaxAmount)}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLineWithHoldTaxAmount(e.target.value)}
                onBlur={e => calcLineWithHoldTaxAmount(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1009}
                name="linePayAmount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={amountFormatter(linePayAmount)}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLinePayAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="tbl-b-00">
            <Col lg="2" className="input-group col-editable" style={{ padding: "0", borderBottom: "solid 1px #AAAAAA" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1013}
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={costCd}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setCostCd(e.target.value)}
                onBlur={e => setCostCd(e.target.value)}
              />
            </Col>
            <Col lg="1" className="col-editable col-remark" style={{ padding: "0", borderBottom: "solid 1px #AAAAAA" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + 1014}
                name="remarkCd"
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={remarkSelected}
                onFocus={e => onFocusCol(e)}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (moveCellByArrow(e)) {
                      return;
                    }
                    if (e.key === "Delete") {
                      handleChangeRemark(null);
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100);
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchRemark(e)}
                onChange={handleChangeRemark}
                onBlur={() => onBlurRemarkCd(remarkCd)}
                placeholder=""
                isClearable
              />
            </Col>
            <Col lg="9" className="input-group col-editable" style={{ padding: "0", borderBottom: "solid 1px #AAAAAA" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1015}
                as="textarea"
                rows={1}
                style={{ fieldSizing: "content", overflow: "hidden", resize: "none", border: "1px solid transparent", backgroundColor: "transparent", padding: "8px" }}
                value={note}
                onKeyDown={e => handleKeyDownNote(e)}
                onFocus={e => onFocusText(e)}
                onChange={e => setNote(e.target.value)}
                onBlur={e => setNote(e.target.value)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
});

export default React.memo(ExpDtlLine);
